module.exports = __webpack_public_path__ + "static/img/dn2.8dbe704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn2.png
// module id = gjW4
// module chunks = 0